import type { CondensatePhaseVolumeFactorBoCalculator } from "../../d";

export const condensatePhaseVolumeFactorBoCalculator: CondensatePhaseVolumeFactorBoCalculator =
  params => {
    const {
      pressurePSIA,
      temperatureF,
      gasSpecificGravity,
      condensateSpecificGravity,
      condensateApi,
      solutionGasRso,
      dewPointPressurePSIA,
      x
    } = params;

    const bo = (rso: number) =>
      1.0113 +
      7.2046 *
        10 ** -5 *
        (rso ** 0.3738 *
          (gasSpecificGravity ** 0.2914 / condensateSpecificGravity ** 0.6265) +
          0.24626 * temperatureF ** 0.5371) **
          3.0936;

    // PVT!BJ109
    const condensateFormationVolumeFactorSatBo = bo(solutionGasRso);

    // PVT!BJ111
    const solutionGasAtDewPointRsb =
      ((dewPointPressurePSIA / 112.727 + 12.34) *
        gasSpecificGravity ** 0.8439 *
        10 ** x) **
      1.73184;

    // PVT!BJ113
    const condensateFormationVolumeFactorAtDewPointBob = bo(
      solutionGasAtDewPointRsb
    );

    // PVT!BJ115 uses the raw condensate API entered at PVT!D22
    const compressibilityUnSatCo =
      1.705 *
      10 ** -7 *
      solutionGasAtDewPointRsb ** 0.69357 *
      gasSpecificGravity ** 0.1885 *
      condensateApi ** 0.3272 *
      temperatureF ** 0.6729 *
      pressurePSIA ** -0.5906;

    // PVT!BJ117
    const compressibilityLimitedUnSatCo = Math.min(
      Math.max(compressibilityUnSatCo, 2.464 * 10 ** -5),
      3.507 * 10 ** -5
    );

    // PVT!BJ119
    const condensateFormationVolumeFactorUnSatBo =
      condensateFormationVolumeFactorAtDewPointBob *
      Math.exp(
        compressibilityLimitedUnSatCo * (dewPointPressurePSIA - pressurePSIA)
      );

    return {
      condensateFormationVolumeFactorSatBo,
      solutionGasAtDewPointRsb,
      condensateFormationVolumeFactorAtDewPointBob,
      compressibilityUnSatCo,
      compressibilityLimitedUnSatCo,
      condensateFormationVolumeFactorUnSatBo
    };
  };
